/**
 * Javascript for product pages
 */
(function (window, document, $, undefined) {
	'use strict';

	var $searchButton = $('.srch-btn');
	var $searchForm = $('.srch-form');
	var $searchInput = $searchForm.find("[name='s']");
	var $searchAgainButton = $('.jh-search-results__search-block-search');
	var $categories = $('.jh-search-results__categories li');
	var $results = $('.jh-search-results__result');
	var $showing = $('.xNum');
	var $total = $('.xTotal');

	var chunkSize = parseInt( $showing.text() );
	var showResults = chunkSize;
	var loadedMoreTimestamp;

	var $menuItemContact = $('#menu-jh-masthead .menu-contact');
	var $menuItemSubscriptions = $('#menu-jh-masthead .menu-subscriptions');
	var $menuItemLogin = $('#menu-jh-masthead .menu-login');

	$searchButton.click(function(e) {

		if ( $(e.target).closest('.srch-form').length > 0 || $(e.target).hasClass('.srch-form') ) {
			return;
		}

		$(this).toggleClass('active');

		if ( $(this).hasClass('active') ) {
			$searchInput.focus();
		}
	});

	$searchAgainButton.click(function(e) {
		var search_term = $('.jh-search-results__search-block-input').val();
		$searchForm.find('[name="s"]').val( search_term );
		$searchForm.find('form').submit();
	});

	$categories.click(function() {

		if ( !$(this).hasClass('active') ) {
			$categories.removeClass('active');
			$(this).addClass('active');
			showResults = chunkSize;
			filter();
		}
	});

	function filter() {

		$results.removeClass('active');

		var filtered_post_type = $categories.filter('.active').attr('data-filter');
		var $newResults = $results;

		if( filtered_post_type !== 'all' ) {
			$newResults = $results.filter( '[data-filter="'+filtered_post_type+'"]' );
		}

		var $newResultsLimited = $newResults.slice(0, showResults).addClass('active');

		$showing.text( $newResultsLimited.length );
		$total.text( $newResults.length );

		loadedMoreTimestamp = Date.now();
	}

	function loadMore() {
		showResults += chunkSize;
		filter();
	}

	function adjustSearchForm(){
		if ($(window).width() < 885) {
			removeSearchFormWidth();
		} else {
			setSearchFormWidth();
		}
	}

	function setSearchFormWidth(){
		// Grabbing the innerWidth value of the masthead nav items to calculate width of the search box
		// This works as expected in Chrome but for some reason is 38px too large in Firefox
		var searchFormWidth = $menuItemContact.innerWidth() + $menuItemSubscriptions.innerWidth() + $menuItemLogin.innerWidth() + $searchButton.innerWidth();
		
		// removing 38 from the width for Firefox
		if (navigator.userAgent.indexOf("Firefox") > 0) {
			searchFormWidth = searchFormWidth - 38;
		}

		$searchForm.find('.searchform').css('width', searchFormWidth + 'px');
	}

	function removeSearchFormWidth(){
		$searchForm.find('.searchform').removeAttr('width');
	}

	$(window).resize(function(){
		adjustSearchForm();
	})

	$(window).scroll(function() {
		if( $results.length > 0 && loadedMoreTimestamp + 150 < Date.now() && showResults < parseInt( $total.text() ) ) {
			if( $(window).scrollTop() + $(window).height() >= $results.filter('.active').last().offset().top ){
				loadMore();
			}
		}
	});

	filter();
	adjustSearchForm();

})( window, document, jQuery );
